<template>
  <div class="support-advice-box">
    <div class="banner"><div class="w"></div></div>
    <div class="w">
      <ul class="news-type-ul">
        <li
          :class="
            item.categoryId == typeActive
              ? 'news-type-li active'
              : 'news-type-li '
          "
          v-for="(item, index) in newsTypeList"
          :key="index"
          @click="clickType(item)"
        >
          {{ item.title }}
        </li>
      </ul>
      <ul class="news-list-ul">
        <li
          class="news-list-li"
          v-for="(item, index) in newsDataList"
          :key="item.id"
        >
          <div
            class="news-image"
            @click="openLink(`/support/advice/detail?id=${item.id}`)"
          >
            <img
              :src="
                item.coverImage ||
                require('@/assets/images/support/news-01.png')
              "
            />
          </div>
          <div
            class="news-content-box"
            @click="openLink(`/support/advice/detail?id=${item.id}`)"
          >
            <div class="title" :title="item.title">{{ item.title }}</div>
            <div
              class="des"
              @click="openLink(`/support/advice/detail?id=${item.id}`)"
            >
              {{ item.description }}
            </div>
            <div class="time">
              发布时间：
              {{
                item.createTime
                  ? moment(item.createTime).format('YYYY.MM.DD')
                  : '--'
              }}
            </div>
            <div
              class="btn"
              @click="openLink(`/support/advice/detail?id=${item.id}`)"
            >
              查看详情
            </div>
          </div>
        </li>
      </ul>
      <div class="pagination_box" v-if="newsDataList.length">
        <el-pagination
          background
          @current-change="currentChange"
          layout="prev, pager, next"
          :current-page="queryParam.pageNum"
          :page-size="queryParam.pageSize"
          :total="queryParam.total"
        >
        </el-pagination>
      </div>
    </div>
    <blockSidebar />
  </div>
</template>
<script>
import(
  `@/assets/css/${
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
      ? 'mobile'
      : 'pc'
  }/support/advice.scss`
)
import blockSidebar from '@/components/block-sidebar'
import moment from 'moment'
export default {
  components: { blockSidebar },
  data() {
    return {
      queryParam: {
        pageNum: 1,
        pageSize: 8,
        total: 0,
      },
      typeActive: '5',
      newsDataList: [],
      newsTypeList: [],
    }
  },
  mounted() {
    const routeParams = this.$route.query
    if (routeParams.type) {
      this.typeActive = routeParams.type
    }
    this.getNewsTypeList()
    this.getNewsDataList()
  },
  methods: {
    moment,
    openLink(path) {
      this.$router.push(path)
    },
    currentChange(v) {
      this.queryParam.pageNum = v
      this.getNewsDataList()
    },
    getNewsTypeList() {
      this.$api.common.getArticleList(9).then((res) => {
        if (res.code === 200) {
          this.newsTypeList = res.data
        }
      })
    },
    clickType(v) {
      this.typeActive = v.categoryId
      this.queryParam.pageNum = 1
      this.getNewsDataList()
    },
    getNewsDataList() {
      const params = {
        categoryId: this.typeActive,
        pageNum: this.queryParam.pageNum,
        pageSize: this.queryParam.pageSize,
      }
      this.$api.news.getArticleListPage(params).then((res) => {
        if (res.code === 200) {
          this.newsDataList = res.rows
          this.queryParam.total = res.total
        }
      })
    },
  },
}
</script>
<style scoped lang="scss">
</style>
